import axios from "axios";
import {Dispatch} from "redux";
import {actions} from "../reducers/PopupPriceCatalogTableReducer";

export const GET_PRICE_CATALOG = "priceCatalog/getList";
export const SET_PRICE_CATALOG_FOR_TEMP_SHUMA = "inspections/updateTempShumaPriceCatalogUsed";

export interface GetListParams {
  mainCategory?: string;
  secondCategory?: string;
  serviceDescription?: string;
  requestedPageNumber?: number | string;
  sortByField?: string;
  sortByOrder?: number;
}

export interface PriceCatalogItem {
  id: number;
  name?: string;
  description?: string;
  [key: string]: any;
}

export interface PriceCatalogResponseBody {
  totalPageCount: number;
  currentPageNumber: number;
  list: PriceCatalogItem[];
  totalResultCount: number;
}

export interface ApiResponse<T> {
  errorCode: number;
  body: T;
}

export const getList = (action: (payload: any) => any) => (params: GetListParams = {}) =>
      async (dispatch: Dispatch) => {
        const {
          mainCategory = "",
          secondCategory = "",
          serviceDescription = "",
          requestedPageNumber = 0,
          sortByField = 'id',
          sortByOrder = -1
        } = params;

        const data = {
          mainCategory,
          secondCategory,
          serviceDescription,
          requestedPageNumber: parseInt(String(requestedPageNumber), 10),
          sortByField,
          sortByOrder
        };

        try {
          const response = await axios.post<ApiResponse<PriceCatalogResponseBody>>(GET_PRICE_CATALOG, data);

          const {errorCode, body} = response.data;

          if (errorCode < 0) {
            throw new Error("API error");
          }

          const {totalPageCount, currentPageNumber, list, totalResultCount} = body;

          dispatch(
            action({
              totalPageCount,
              currentPageNumber,
              list,
              totalResultCount,
            })
          );
        } catch (error: any) {
          error.clientMessage = "Can't find data";
          dispatch(actions.catchError(error));
        }
      };

export const setPriceCatalogForTempShuma = async (tempShumaID: string) => {
    const data = {
      tempShumaID,
      isPriceCatalogUsed: true
    };

    try {
      const response = await axios.post(SET_PRICE_CATALOG_FOR_TEMP_SHUMA, data);
      const {errorCode} = response.data;

      if (errorCode < 0) {
        throw new Error("API error");
      }

    } catch (error: any) {
      error.clientMessage = "Can't set data";
    }
  };

export const getPriceCatalogItems = getList(actions.priceCatalogFetched);
export const getNextPriceCatalogItems = getList(actions.priceCatalogAppended);